<template>
  <v-dialog
    content-class="password-spray-scan-initiated-popup"
    :value="visiblePopup"
    @click:outside='saveClicked'
    @keydown.esc="saveClicked"
    :width="750"
  >
    <v-card class="popup-wrapper">
      <div class='content'>
        <div class="title">{{$t('password.spray.scan.initiated.popup.title')}}</div>
        <div class="message">{{$t('password.spray.scan.initiated.popup.message')}}</div>
        <span v-if='notValidatedDomains.length > 0'>
          <v-alert
            text
            dense
            color="#ff7f00"
            icon="info"
            border="left"
            class='not-valid-message'
          >
            <div>
              {{notValidatedDomainsTitle}}
              <v-btn class='copy' icon @click="copyNotValidatedData">
                <v-icon>content_copy</v-icon>
              </v-btn>
            </div>
            <div>
              {{notValidatedDomainsMessage}}
            </div>
          </v-alert>
        </span>
        <span v-if='domainsWithoutLicense.length > 0'>
          <v-alert
            text
            dense
            color="#ff7f00"
            icon="info"
            border="left"
            class='not-valid-message'
          >
            <div>
              {{domainsWithoutLicenseTitle}}
              <v-btn class='copy' icon @click="copyNotLicensedData">
                <v-icon>content_copy</v-icon>
              </v-btn>
            </div>
            <div>
              {{domainsWithoutLicenseMessage}}
            </div>
          </v-alert>
        </span>
        <div class='buttons'>
          <v-btn
            small
            color="#4D9FEB"
            class="save-button"
            @click='saveClicked'
          >
            {{ $t('password.spray.initiated.popup.ok') }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';
import {mapGetters} from 'vuex';

export default {
  name: 'PasswordSprayScanInitiatedPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    visiblePopup: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async saveClicked() {
      await this.$emit('save');
    },
    copyNotValidatedData() {
      navigator.clipboard.writeText(this.notValidatedDomains.join(', '));
    },
    copyNotLicensedData() {
      navigator.clipboard.writeText(this.domainsWithoutLicense.join(', '));
    },
  },
  computed: {
    ...mapGetters(['notValidatedDomains', 'domainsWithoutLicense']),
    notValidatedDomainsForMessage() {
      return this.notValidatedDomains.length > 25 ? `${this.notValidatedDomains.slice(0, 25).join(', ')}...` : this.notValidatedDomains.join(', ');
    },
    notLicencedDomainsForMessage() {
      return this.domainsWithoutLicense.length > 25 ? `${this.domainsWithoutLicense.slice(0, 25).join(', ')}...` : this.domainsWithoutLicense.join(', ');
    },
    notValidatedDomainsTitle() {
      return `${this.$t('scan.disable.no.domain.validation.password.spray')}`;
    },
    notValidatedDomainsMessage() {
      return `${this.notValidatedDomainsForMessage}`;
    },
    domainsWithoutLicenseTitle() {
      return `${this.$t('scan.disable.no.license.password.spray')}`;
    },
    domainsWithoutLicenseMessage() {
      return `${this.notLicencedDomainsForMessage}`;
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/design-system';

.password-spray-scan-initiated-popup {
  .copy {
    position: absolute;
    right: $space-2;
    top: rem(1);
  }

  .copy {
    &.v-btn {
      &:hover::before,
      &:hover::after,
      &:active::after,
      &:active::before,
      &:focus::after,
      &:after,
      &:before,
      &:focus::before {
        background-color: transparent;
        box-shadow: none;
        border-color: inherit;
        opacity: inherit;
      }

      .v-ripple {
        &__container {
          display: none;
        }
      }
    }
  }

  .v-btn--icon.v-size--default .v-icon {
    width: $font-size-sm;
    height: $font-size-sm;
    font-size: $font-size-md;
  }

  .popup-wrapper {
    max-width: rem(750);
    padding: $space-8 $space-10;

    .content {
      .title {
        color: var(--text-primary);
        font-size: $font-size-base;
        font-weight: 600;
        letter-spacing: 1.12px;
        line-height: $space-4;
        text-transform: uppercase;
        padding-bottom: $space-6;
      }

      .message {
        font-weight: normal;
        color: var(--text-primary);
        font-size: $font-size-base;
        letter-spacing: 0;
        line-height: $space-4;
        white-space: pre-line;
        margin-bottom: $space-5;
      }

      .not-valid-message {
        font-size: $font-size-xs;
        font-weight: 600;
        letter-spacing: 1.12px;
        line-height: $space-4;
        white-space: pre-line;

        &:hover,
        &:focus-within,
        &:active,
        &:focus {
          background-color: inherit;
          box-shadow: none;
          border-color: inherit;
          opacity: inherit;
        }
      }
    }

    .buttons {
      text-align: right;

      .save-button {
        border-radius: $radius-sm;
        background-color: var(--brand-primary);
        box-shadow: $shadow-sm;
        color: var(--text-inverse);
        font-size: $font-size-sm;
        font-weight: 500;
        letter-spacing: 1.07px;
        line-height: $space-4;
        text-align: center;
        margin-left: $space-2;
      }
    }
  }
}
</style>
